import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "../lib/api";
import SEO from "../components/SEO";
import WalkCard from "../components/WalkCard";
import FilterSelect from "../components/FilterSelect";

const THEMES = [
    { value: "", label: "Tous les thèmes" },
    { value: "Forêt", label: "Forêt" },
    { value: "Falaises", label: "Falaises" },
    { value: "Mer & patrimoine", label: "Mer & patrimoine" },
    { value: "Romantique", label: "Romantique" },
    { value: "Famille", label: "Famille" },
    { value: "Photo", label: "Photo" },
];

export default function Balades() {
    const [params, setParams] = useSearchParams();
    const [walks, setWalks] = useState([]);
    const theme = params.get("theme") || "";

    useEffect(() => {
        api.get("/walks", { params: { theme: theme || undefined, limit: 50 } })
            .then((r) => setWalks(r.data)).catch(() => {});
    }, [theme]);

    const update = (v) => {
        const next = new URLSearchParams(params);
        if (!v) next.delete("theme"); else next.set("theme", v);
        setParams(next);
    };

    return (
        <>
            <SEO
            title="Balades & randonnées — Normandie & Picardie"
            description="11 randonnées vérifiées avec traces GPX : Forêt d'Eu (Rieux, Saint-Pierre-en-Val, Reine-Mère, Gérente, Incheville), falaises Le Tréport, vallée de la Bresle, Mers-les-Bains."
            path="/balades"
        />
            <div className="pt-28" data-testid="walks-page">
            <section className="px-6 md:px-12 max-w-[1600px] mx-auto pt-16 md:pt-24 pb-16">
                <p className="cp-tiny text-cp-foret mb-8">Chapitre IV · Balades</p>
                <h1 className="cp-serif text-4xl sm:text-5xl md:text-[56px] lg:text-[72px] xl:text-[92px] leading-[1.02] text-cp-encre max-w-5xl tracking-[-0.025em]">
                    Marcher,<br /><em className="cp-display-italic text-cp-foret">comme on</em> écrit.
                </h1>
                <p className="cp-serif italic text-xl md:text-2xl font-light text-cp-gris leading-relaxed mt-12 max-w-3xl">
                    Des itinéraires ciselés pour chaque envie, chaque saison, <em>chaque heure de la journée</em>.
                </p>
            </section>

            <section className="px-6 md:px-12 max-w-[1600px] mx-auto py-5 border-y border-cp-border mb-12 sticky top-20 md:top-24 z-30 bg-cp-ivoire/95 backdrop-blur-xl" data-testid="walks-filters">
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 items-end">
                    <FilterSelect
                        label="Thème"
                        value={theme}
                        onChange={update}
                        testId="walk-filter-theme"
                        options={THEMES}
                    />
                    <p className="cp-tiny text-cp-gris sm:col-span-1 md:col-span-3 text-left sm:text-right self-center pt-4">
                        {walks.length} balade{walks.length > 1 ? "s" : ""}
                        {theme && <button onClick={() => update("")} className="ml-3 text-cp-foret hover:underline cp-serif italic" data-testid="walk-filter-reset">Tout effacer ×</button>}
                    </p>
                </div>
            </section>

            <section className="px-6 md:px-12 max-w-[1600px] mx-auto pb-32">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12">
                    {walks.map((w, i) => <WalkCard key={w.id} walk={w} index={i} />)}
                </div>
            </section>
        </div>
    </>

    );
}
